import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72804f9b")

_pushScopeId("data-v-72804f9b")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col left-arrow" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "create-parag" }
const _hoisted_11 = { class: "news-create-heading" }
const _hoisted_12 = { class: "create-parag" }
const _hoisted_13 = { class: "news-create-heading" }
const _hoisted_14 = { class: "path-image" }
const _hoisted_15 = { class: "button-using" }
const _hoisted_16 = { class: "button-cancel" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/admin/faq",
            class: "link section__link"
          }, {
            default: _withId(() => [
              _createVNode(_component_svg_icon, { name: "arrow-left" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('login.back')), 1 /* TEXT */)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("h1", null, _toDisplayString(_ctx.$t('panelAdminFaq.CreateTab')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.faqPost(...args)), ["prevent"])),
            class: "form login__form"
          }, [
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('panelAdminFaq.question')), 1),
            _createVNode("div", _hoisted_11, [
              _withDirectives(_createVNode("textarea", {
                name: "",
                id: "",
                cols: "30",
                rows: "2",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.data.title = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.title]
              ])
            ]),
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('panelAdminFaq.Answer')), 1),
            _createVNode("div", _hoisted_13, [
              _withDirectives(_createVNode("textarea", {
                name: "",
                id: "",
                cols: "30",
                rows: "5",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.data.content = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.content]
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("button", _hoisted_15, _toDisplayString(_ctx.$t('profile.save')), 1),
              _createVNode("button", _hoisted_16, _toDisplayString(_ctx.$t('profile.cancel')), 1)
            ])
          ], 32)
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
})